import { jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from '@commercial-website/icons/index';
/**
 * Builds `count` interchangeable sample cards. Kept as a factory (rather than a fixed array) so
 * stories can exercise 1-, 2-, 3- and 4-card layouts from one definition.
 */
export const makeCardRowCards = (count) => Array.from({ length: count }, (_, index) => ({
    title: `Card ${index + 1}`,
    body: 'Issue cards, pay bills, and automatically sync your books in the background.',
    media: {
        image: (_jsx("img", { src: "https://placehold.co/600x720", alt: "", width: 600, height: 720, loading: "lazy" })),
    },
    cta: {
        href: '/en/customers',
        icon: _jsx(Arrow, {}),
        render: ({ children, ...props }) => _jsx("a", { ...props, children: children }),
    },
}));
export const cardRowMock = {
    columnCount: 3,
    cards: makeCardRowCards(3),
};
